import React from "react";
import { Spinner } from "reactstrap";

export const Loader = (props) => {
  const { boxClass } = props;
  return (
    <div className={boxClass}>
      <Spinner color="secondary" size="">
        Loading...
      </Spinner>
    </div>
  );
};
